export default "__VITE_ASSET__Df06d9dp__"